import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { IconComponent, Illustration, IllustrationComponent, PageComponent } from '@ftr/foundation'
import { featureFlag } from '@ftr/ui-feature-flags'

@Component({
  selector: 'ftr-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  imports: [RouterModule, IllustrationComponent, PageComponent, IconComponent],
})
export class NotFoundComponent {
  readonly illustration = Illustration

  protected isPublicNavigationEnabled = featureFlag('public-navigation')
}
